import type { TFunction } from 'i18next';
import type { OneTimeSchedule, RecurringSchedule } from '../../api/tasks';

/** One sentence for a task's schedule, in the shape the schedule has. */
export function scheduleText(
  t: TFunction<'pleri/pages'>,
  schedule: OneTimeSchedule | RecurringSchedule,
): string {
  if ('runAt' in schedule) {
    return t('oneTimeAt', { time: new Date(schedule.runAt).toLocaleString() });
  }
  const values = {
    frequency: schedule.frequency,
    time: schedule.time,
    timezone: schedule.timezone,
  };
  if (schedule.frequency === 'weekly' && schedule.dayOfWeek !== undefined) {
    return t('recurringOnDayOfWeekAt', { ...values, day: schedule.dayOfWeek });
  }
  if (schedule.frequency === 'monthly' && schedule.dayOfMonth !== undefined) {
    return t('recurringOnDayOfMonthAt', {
      ...values,
      day: schedule.dayOfMonth,
    });
  }
  return t('recurringAt', values);
}
